import React, { useEffect } from 'react';
import DivisionItem from './items/DivisionItem';
import CategoryItem from './items/CategoryItem';
import SectionItem from './items/SectionItem';
import ResourceTypeItem from './items/ResourceTypeItem';
import RegionItem from './items/RegionItem';
import FooterSectionItem from './items/FooterSectionItem'; // 👈 NEW
import TertiaryCustomButton from '../../../../commons/tertiary-custom-button/tertiary-custom-button';
import { isString } from './constant';
import MenuHeader3 from './MenuHeader3';
import PrimaryCustomButton from '../../../../commons/primary-custom-button/primary-custom-button.component';

export default function MenuList({
    items = [],
    divisions = [],
    setDivisions,
    onNext,
    onClose,
    hasBack,
    setHasNestedBack,
    hasNestedBack,
    currentTitle,
    currentSubtitle,
    onNestedBack,
    contactUsCta,
    siginInCta,
    footerData = {},
    parentViewAll, // <-- add this
    resourcesFeatured
}) {
    useEffect(() => {
        if (divisions.length > 0) {
            // console.log('divisions', divisions);
        }
    }, [divisions]);

    useEffect(() => {
        // console.log('items for back title', items);
    }, [items]);

    console.log('contactUsCta', contactUsCta);
    console.log('items', items);
    console.log('parentViewAll', parentViewAll);

    return (
        <>
            <ul className="menu-list test">
                {hasNestedBack && hasNestedBack != 'Resources' && (
                    <MenuHeader3
                        title={hasNestedBack}
                        onBack={onNestedBack}
                        hasNestedBack={hasNestedBack}
                    />
                )}
                {currentTitle === 'Locations' && hasNestedBack && (
                    <div className="location-nested-title">{currentSubtitle}</div>
                )}
                {currentTitle === 'Industries' && !hasNestedBack && (
                    <div className="industries-title">{currentTitle}</div>
                )}
                {(currentTitle === 'Software' ||
                    currentTitle === 'Training' ||
                    currentTitle === 'About Us') &&
                    hasNestedBack && (
                        <div className="software-subtitle">{currentSubtitle}</div>
                    )}
                {currentTitle === 'Locations' && !hasNestedBack && (
                    <div className="industries-title">Offices</div>
                )}
                {items.map((item, idx) => {
                    // Footer submenu screen (Join Our Team)
                    if (item && item.type === 'footer-sections') {
                        return (
                            <FooterSectionItem
                                key={`footer-sections-${idx}`}
                                sections={Array.isArray(item.sections) ? item.sections : []}
                                featured={item.featured || null}
                            />
                        );
                    }

                    //  Existing: Division grid (Expertise)
                    if (item?.type === 'division-grid' && item.division && idx === 0) {
                        const divisionList = divisions.length ? divisions : [item.division];
                        return (
                            <li key={idx} className="division-item">
                                <div className="mobile-grid expertise">
                                    {divisionList.map((division) => (
                                        <div className="menu-column" key={division.code}>
                                            <a href={division.href} className="menu-title">
                                                {division.code} Division
                                            </a>
                                            <p className="menu-subtitle">{division.title}</p>
                                            <ul className="menu-list">
                                                {division.services.map((service, sIdx) => (
                                                    <li key={sIdx}>
                                                        <a href={service.href} className="menu-link">
                                                            {service.text}
                                                        </a>
                                                    </li>
                                                ))}
                                            </ul>
                                            <a href={division.view_all.href} className="view-all">
                                                {division.view_all.text}
                                            </a>
                                        </div>
                                    ))}
                                </div>
                            </li>
                        );
                    }

                    // Expertise entrypoint
                    if (item?.type === 'megamenu' && item.content?.divisions) {
                        return (
                            <DivisionItem
                                key={idx}
                                item={item}
                                divisions={item.content.divisions}
                                onNext={onNext}
                                onDivisionClick={(d) => setDivisions(d)}
                            />
                        );
                    }

                    // Industries entrypoint
                    if (item?.type === 'megamenu' && item.content?.categories) {
                        return <CategoryItem key={idx} item={item} onNext={onNext} />;
                    }

                    // Software, Training, About Us entrypoint (HEADER SECTIONS)
                    if (item?.type === 'megamenu' && item.content?.sections) {
                        return <SectionItem key={idx} item={item} onNext={onNext} />;
                    }

                    // Resources entrypoint
                    if (item?.type === 'megamenu' && item.content?.resource_types) {
                        return (
                            <ResourceTypeItem
                                key={idx}
                                item={item}
                                onClose={onClose}
                                onNext={onNext}
                            />
                        );
                    }

                    // Locations entrypoint
                    if (item?.type === 'megamenu' && item.content?.regions) {
                        const order = [
                            'United States',
                            'Asia',
                            'North America',
                            'Europe',
                            'Oceania',
                        ];

                        // Reorder the regions array in-place
                        item.content.regions = order
                            .map((title) =>
                                item.content.regions.find((r) => r.title === title)
                            )
                            .filter(Boolean); // remove any undefined if title not found

                        return <RegionItem key={idx} item={item} onNext={onNext} />;
                    }

                    // Back helper for plain strings
                    if (isString(item)) {
                        if (currentTitle == 'Locations') {
                            setHasNestedBack?.('Locations');
                        } else {
                            setHasNestedBack?.('Back');
                        }
                    }

                    if (item && item.text) {
                        setHasNestedBack?.(currentTitle);
                        return (
                            <li key={idx}>
                                <a
                                    className={`mobile-nav-sub-items ${currentTitle === 'Resources' ? 'resource-nest-ele' : ''
                                        }`}
                                    href={item.href}>
                                    {item.text}
                                </a>
                            </li>
                        );
                    }

                    // Default fallback for buttons / plain anchor
                    return divisions.length ? null : (
                        <li key={idx}>
                            {item?.title ? (
                                <TertiaryCustomButton
                                    title={item.title || item}
                                    onClick={() =>
                                        onNext(
                                            item.items || item.countries || item.states,
                                            currentTitle,
                                            item.title
                                        )
                                    }
                                    classes={`customize-tertiary-cls ${currentTitle === 'Industries'
                                            ? 'capital'
                                            : currentTitle === 'Locations'
                                                ? 'light-capital'
                                                : ''
                                        }`}
                                />
                            ) : (
                                <a
                                    className={`mobile-nav-sub-items ${currentTitle === 'Locations' ? 'fs-14' : ''
                                        }`}
                                    href="https://trinityconsdev.wpenginepowered.com/">
                                    {item}
                                </a>
                            )}
                        </li>
                    );
                })}

                {/* ================== DIVIDER BETWEEN MAIN + FOOTER ================== */}
                {!hasBack && Object.keys(siginInCta || {}).length > 0 && (
                    <li className='sign-in-container'>
                        <a className='siginInCta' href={siginInCta.href} >{siginInCta.text}</a>
                    </li>
                )}

                {!hasBack && Object.keys(contactUsCta || {}).length > 0 && (
                    <PrimaryCustomButton
                        title={contactUsCta.text}
                        customClass={'contact-us-custom-style'}
                        href={contactUsCta.href}
                    />
                )}

                {!hasBack && Object.keys(footerData || {}).length > 0 && (
                    <li className="mobile-menu-divider-wrapper">
                        <div className="mobile-menu-divider"></div>
                    </li>
                )}

                {/* ================== FOOTER ITEMS (LEVEL 1) ================== */}
                {!hasBack &&
                    Object.entries(footerData || {}).map(([key, item], idx) => {
                        if (!item) return null;

                        // Simple link (e.g., Subscribe)
                        if (item.href && item.text) {
                            return (
                                <li key={`footer-${idx}`}>
                                    <TertiaryCustomButton
                                        href={item.href}
                                        title={item.text}
                                        classes={'customize-tertiary-cls'}
                                    />
                                </li>
                            );
                        }

                        // Dropdown (Join Our Team)
                        if (item.dropdown && item.text) {
                            const sections = Array.isArray(item.dropdown.sections)
                                ? item.dropdown.sections
                                : [];

                            // Support both "featured_content" and "feature" keys
                            const featured =
                                item.dropdown.featured_content || item.dropdown.feature || null;

                            return (
                                <li key={`footer-${idx}`}>
                                    <TertiaryCustomButton
                                        title={item.text}
                                        onClick={() =>
                                            onNext(
                                                [
                                                    {
                                                        type: 'footer-sections',
                                                        sections,
                                                        featured,
                                                    },
                                                ],
                                                currentTitle,
                                                item.text
                                            )
                                        }
                                        classes={'customize-tertiary-cls footer-custom-btn'}
                                    />
                                </li>
                            );
                        }

                        return null;
                    })}

                {parentViewAll && (
                    <TertiaryCustomButton
                        title={parentViewAll.text}
                        href={parentViewAll.href}
                        classes={
                            currentTitle === 'Industries'
                                ? 'customize-tertiary-cls fs-13 fw-400 mt-50 mb-50'
                                : currentTitle === 'Resources'
                                    ? 'customize-tertiary-cls fs-12 fw-400'
                                    : currentTitle === 'Locations'
                                        ? 'customize-tertiary-cls mt-50 mb-50'
                                        : 'customize-tertiary-cls'
                        }
                    />
                )}

                {currentTitle === 'Resources' && (() => {
                const featured = resourcesFeatured;

                return featured.length > 0 ? (
                    <div className="mobile featured-content menu-column">
                        <div className="featured-grid">
                            {featured.slice(0, 2).map((item, idx) => (
                            <article className="featured-card" key={idx}>
                                {item.badge && <span className="badge">{item.badge}</span>}
                                <p className="menu-title">{item.title}</p>
                                {item.description && <p className="menu-subtitle">{item.description}</p>}
                                {item.cta && (
                                <a href={item.cta.href} className="view-all">
                                    {item.cta.text}
                                </a>
                                )}
                            </article>
                            ))}
                        </div>
                    </div>
                ) : null;
                })()}
            </ul>
        </>
    );
}
